import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import styles from './AdminStatus.styles';
import {
  getRpDetailAction,
  getApDetailAction,
  getGatewayDetailAction,
  resetStatusAction,
  getStatusSummaryAction
} from '../../reducers/actions';
import ReferencePointRow from '../../components/data/status/referencepoint/referencePointRow';
import AccessPointTableHeader from '../../components/data/status/accesspoint/accessPointTableHeader';
import { AccessPointRow } from '../../components/data/status/accesspoint/accessPointRow';
import ReferencePointTableHeader from '../../components/data/status/referencepoint/referencePointTableHeader';
import GatewayTableHeader from '../../components/data/status/gateway/gatewayTableHeader';
import GatewayRow from '../../components/data/status/gateway/gatewayRow';
import AdminTitleBar from '../../components/common/admintitlebar/AdminTitleBar';
import ErrorBoundary from '../../components/common/errorboundary/ErrorBoundary';
import { styleCss } from '../adminusers/AdminUsers.styles';
//import { getSitesAction } from '../../reducers/actions';
import { getOrgSitesAction } from '../../reducers/actions';
import { getSelectedSite } from '../adminusers/util';
import { refreshTimeInterval } from '../../constants/status';
import AccessPoints from '../../components/data/status/accesspoint';
import Gateways from '../../components/data/status/gateway';
import { ReferencePoints } from '../../components/data/status/referencepoint';
import { statusActiveBackground } from '../../constants/status';
import Error from '../../components/common/errorBanner/error';
import { isValid } from '../../utils/validation';
import  LoadingMask from '../../components/common/LoadingMask.js';
import { dateFormat, formatDate } from '../../models/status/utils.js';

export class AdminStatus extends Component {
  constructor(props) {
    super(props);
    const { sites } = props;
    let currentSite = getSelectedSite(sites) || sites[0];

    let currentSiteId = localStorage.getItem(`airfinder_selected_site`);
    this.props.getStatusSummary(currentSiteId);

    this.state = {
      showAddModal: false,
      dropdownValue: (currentSite && currentSite.value) || '',
      sites: sites,
      activeDiv: '',
      showDeleteModal: false,
      selectedRowData: null,
      time: new Date(),
      initLoading: true
    };
  }

  componentDidMount() {
    // Required to get sites data into dropdown.
    //this.props.getOrgSites(localStorage.getItem('orgId'))
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
    this.interval = setInterval(() => {
      this.setState({time: new Date()})
      let currentSiteId = localStorage.getItem(`airfinder_selected_site`);
      this.props.getStatusSummary(currentSiteId);
      this.props.showAp && this.props.getApDetail(currentSiteId);
      this.props.showGateway && this.props.getGatewayDetail(currentSiteId);
      this.props.showRp && this.props.getRpDetail(currentSiteId);
    }, refreshTimeInterval);
    if (this.props.location.hash === '#/?RP=true') {
      this.rowDisplay('showRps');
    } else if (this.props.location.hash === '#/?AP=true') {
      this.rowDisplay('showAps');
    } else if (this.props.location.hash === '#/?Gateways=true') {
      this.rowDisplay('showGateway');
    }
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    //old n new not equal and the array is not empty then set
    const { sites } = nextProps;
    let currentSite = getSelectedSite(sites) || sites[0];
    if (prevState.sites.length !== sites.length && currentSite) {
      return { dropdownValue: currentSite.value }; // <- this is setState equivalent
    }
    return null;
  }

  rowDisplay = content => {
    let currentSiteId = localStorage.getItem(`airfinder_selected_site`);
    let activeObj = {},
      methodToReturn;
    switch (content) {
      case 'showRps':
        activeObj = {
          activeDiv: content
        };
        methodToReturn = this.props.getRpDetail(currentSiteId);
        break;
      case 'showAps':
        activeObj = {
          activeDiv: content
        };
        methodToReturn = this.props.getApDetail(currentSiteId);
        break;
      case 'showGateway':
        activeObj = {
          activeDiv: content
        };
        methodToReturn = this.props.getGatewayDetail(currentSiteId);
        break;
      default:
    }
    activeObj.initLoading = true;
    this.setState(activeObj);
    return methodToReturn;
  };
  onSiteChange(newSite) {
    const site = newSite && newSite.value;
    this.props.resetStatusDetails();
    this.props.getStatusSummary(site);
    this.setState(
      { dropdownValue: site },
      localStorage.setItem(`airfinder_selected_site`, site)
    );
  }

  handleDeleteModalState = selectedRowData => {
    this.setState({
      showDeleteModal: !this.state.showDeleteModal,
      selectedRowData
    });
  };
  renderStatus = () => {
    // if(!this.props.statusSummary || this.props.statusSummary.length === 0){
    //   return;
    // }

    let apstats = {};
    let gwstats = {};
    let rpstats = {};
    if(this.props.statusSummary){
      apstats = this.props.statusSummary['ACCESS_POINT'] || {}
      gwstats = this.props.statusSummary['GATEWAY'] || {}
      rpstats = this.props.statusSummary['LOCATION'] || {}
    }
    return (
      <Fragment>
        <Gateways
          {...this.props}
          summary = {gwstats}
          rowDisplay={this.rowDisplay}
          activeBackground={
            this.state.activeDiv === 'showGateway' && statusActiveBackground
          }
          showModal={this.state.showDeleteModal && this.props.showGateway}
          handleDeleteModal={this.handleDeleteModalState}
          selectedRowData={this.state.selectedRowData}
        />
        <AccessPoints
          {...this.props}
          summary = {apstats}
          rowDisplay={this.rowDisplay}
          activeBackground={
            this.state.activeDiv === 'showAps' && statusActiveBackground
          }
          showModal={this.state.showDeleteModal && this.props.showAp}
          handleDeleteModal={this.handleDeleteModalState}
          selectedRowData={this.state.selectedRowData}
        />
        <ReferencePoints
          {...this.props}
          summary={rpstats}
          rowDisplay={this.rowDisplay}
          activeBackground={
            this.state.activeDiv === 'showRps' && statusActiveBackground
          }
        />
      </Fragment>
    );
  };
  render() {
    const { sites, showRp, showAp, showGateway, errorMessage } = this.props;
    const {
      gatewayData,
      accessPointData,
      referencePointData
    } = this.props.status;
    let siteOpts = sites.map(s=>{
      return (<option value={s.value} key={s.value}>{s.label}</option>)
    })
    return (
      <div className={css(styleCss.base)}>
        <ErrorBoundary>
          <AdminTitleBar
            title={I18n.t('admin.network')}
            addButtonRemove={true}
          />
          <select
            className={`${css(styles.position)} ${css(styles["site-select"])} ui-dropdown ui-widget ui-state-default ui-corner-all ui-helper-clearfix`}
            name="input-name"            
            value={this.state.dropdownValue}
            onChange={e => this.onSiteChange(e.target)}>
            {siteOpts}
            </select>
        </ErrorBoundary>
        <ErrorBoundary>
          <p>{I18n.t('data.asOfDate', {date: formatDate(this.state.time.toLocaleString(), dateFormat)})}</p>
          <LoadingMask show={this.state.initLoading && this.props.loading} />
          <content className={css(styles.content)}>
            <div>{isValid(errorMessage) && <Error msg={errorMessage} />}</div>
            <div className={css(styles.base, styles.flex)}>
              {this.renderStatus()}
            </div>
            {showRp ? (
              <div>
                <ReferencePointTableHeader />
                {referencePointData && referencePointData.length === 0 ? (
                  <ReferencePointRow />
                ) : (
                  referencePointData &&
                  referencePointData.map((status, index) => (
                    <ReferencePointRow key={status.id} status={status} />
                  ))
                )}
              </div>
            ) : (
              ''
            )}
            {showAp ? (
              <div>
                <AccessPointTableHeader />
                {accessPointData && accessPointData.length === 0 ? (
                  <AccessPointRow />
                ) : (
                  accessPointData &&
                  accessPointData.map((status, index) => (
                    <AccessPointRow
                      key={status.id}
                      status={status}
                      handleDeleteModalState={this.handleDeleteModalState}
                    />
                  ))
                )}
              </div>
            ) : (
              ''
            )}
            {showGateway ? (
              <div>
                <GatewayTableHeader />
                {gatewayData && gatewayData.length === 0 ? (
                  <GatewayRow />
                ) : (
                  gatewayData &&
                  gatewayData.map((status, index) => (
                    <GatewayRow
                      key={status.nodeAddress}
                      status={status}
                      handleDeleteModalState={this.handleDeleteModalState}
                    />
                  ))
                )}
              </div>
            ) : (
              ''
            )}
          </content>
        </ErrorBoundary>
      </div>
    );
  }
}
const mapStateToProps = state => {
  const sites = state.sites.list.map(site => ({
    label: site.name,
    value: site.id
  }));
  return {
    loading: state.status.loading,
    status: state.status,
    sites,
    showRp: state.status.showRp,
    showAp: state.status.showAp,
    showGateway: state.status.showGateway,
    statusSummary: state.status.statusSummary,
    errorMessage: state.errorBanner.errorMessage
  };
};
const mapDispatchToProps = dispatch => {
  return {
    getRpDetail(siteId) {
      dispatch(getRpDetailAction(siteId));
    },
    getApDetail(siteId) {
      dispatch(getApDetailAction(siteId));
    },
    getGatewayDetail(siteId) {
      dispatch(getGatewayDetailAction(siteId));
    },
    getSites() {
      dispatch(getOrgSitesAction(...arguments));
    },
    getOrgSites(orgid) {
      dispatch(getOrgSitesAction(orgid));
    },
    resetStatusDetails() {
      dispatch(resetStatusAction(...arguments));
    },
    getStatusSummary() {
      dispatch(getStatusSummaryAction(...arguments));
    }
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminStatus);



// WEBPACK FOOTER //
// ./src/containers/adminstatus/AdminStatus.js